<template>
  <generic-modal :title="$t('link')" ref="generic_modal">
    <form>
      <div class="field">
        <generic-dropdown
          :title="$t('profile')"
          :placeholder="$t('select one')"
          url="/shortlink/profile/catalog"
          name_field="name"
          value_field="profile_id"
          @selected="set_profile"
          ref="profile_dropdown"
          :is_multiple="false"
        />
      </div>

      <div class="field">
        <label class="label">{{ $t("original url") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="url"
            class="input"
            v-model="meta.original_url"
            :placeholder="$t('original url')"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-link"></i>
          </span>
        </p>
      </div>
    </form>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  get,
  generate_error_message_text,
  success_message,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "LinkModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      profiles: [],
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return !v.meta.profile_id || !v.meta.original_url;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    // edit_modal(link_uuid) {
    //   let v = this;
    //   v.set_initial_state();
    //   get("/shortlink/link", { uuid: link_uuid })
    //     .then((link) => {
    //       v.meta = link;
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    //   v.$refs.generic_modal.show_modal();
    // },
    save() {
      let v = this;
      let link = { ...v.meta };
      v.$root.loader(true);
      put("/shortlink/link", link)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => v.$root.loader(false));
    },

    set_initial_state() {
      let v = this;
      v.meta = {
        profile_id: "",
        original_url: "",
      };
      v.error = "";
      v.$refs.profile_dropdown.clear();
    },
    set_profile(selected) {
      let v = this;
      if (selected) {
        v.meta.profile_id = selected.profile_id;
      }
    },
  },
  mounted() {},
};
</script>

<style></style>
